/** События набора note.notes */
export enum EnumNoteEvent {
  CREATED = 'created',
  RENAMED = 'renamed',
  CONTENT_CHANGED = 'content_changed',
  CONFLICT_RESOLVED = 'conflict_resolved',
  REMOVED = 'removed',
  RESTORED = 'restored',
  /** Файл приложен: {file, size, chunk, key, meta} (2-1-5-add-note-files, КС-1) */
  FILE_ATTACHED = 'file_attached',
  /** Файлы убраны из заметки: {files: uuid[]} */
  FILES_REMOVED = 'files_removed',
}

/** События набора note.tabs */
export enum EnumTabsEvent {
  TABS_CHANGED = 'tabs_changed',
}
